import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { OtpPage } from '../otp/otp.page';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-socail-mobile-verified',
  templateUrl: './socail-mobile-verified.component.html',
  styleUrls: ['./socail-mobile-verified.component.scss'],
})
export class SocailMobileVerifiedComponent implements OnInit {
  Signup_validations: FormGroup;
  validation_errors: any;
  @Input() email: string;
  @Input() pageType: boolean = false;
  @Input() forceNumber: boolean = false;

  constructor(
    private FormBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private auth: AuthenticationStore,
    private loaderService: LoaderService,
    private translate: TranslateService
  ) {}

  async verifyotp() {
    this.loaderService.showLoading();
    try {
      await this.auth.signUpSocial(this.Signup_validations.value);
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        this.translate.instant('COMPANY_SELLER.OTP_SENT_MESSAGE'),
        'bottom',
        'success',
        2000
      );
      const modal = await this.modalCtrl.create({
        component: OtpPage,
        componentProps: {
          socailSignUpPayload: this.Signup_validations.value,
          pageType: this.pageType,
        },
      });
      modal.present();
      this.modalCtrl.dismiss();
      this.Signup_validations.reset();
    } catch (error) {
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'middle',
        'danger',
        5000
      );
      this.loaderService.dismissLoading();
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.getErrors();
    this.Signup_validations = this.FormBuilder.group({
      phone: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(9)])
      ),
      otp: new FormControl(),
      // phone_code: new FormControl('+244'),
      email: this.email,
    });
  }
  getErrors() {
    this.validation_errors = {
      phone: [
        {
          type: 'required',
          message: `ACCOUNT_PAGE.SIGN_UP.SIGNUP_SUB_SECTION.REQUIRED_NUMBER`,
        },
        {
          type: 'minlength',
          message: `ACCOUNT_PAGE.SIGN_UP.SIGNUP_SUB_SECTION.PHONE_LENGTH`,
        },
      ],
    };
  }
}
